// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content_33WTc","footer":"index_footer_9MwrN"};